enum InfantFeedingType {
    Unknown,
    BreastMilkOnly,
    BreastMilkSubstituteOnly,
    CombinationOfBreastMilkAndSubstitute
}

export { InfantFeedingType };
